module.exports = __webpack_public_path__ + "static/media/magical-ding-pop-notification.80c3f258.mp3";